exports.mapIconsText = [
    ["lakme_store", "https://s3-ap-southeast-1.amazonaws.com/locauditooh-images/lakme2.png"],
    ["olx_car_store", "https://s3-ap-southeast-1.amazonaws.com/locauditooh-images/olx_car.png"],
    ["one_plus_store","https://locauditooh-images.s3-ap-southeast-1.amazonaws.com/one_plus_60x60.png"],
    [ "art_gallery", "https://maps.gstatic.com/mapfiles/place_api/icons/art_gallery-71.png" ],
    [ "atm", "https://maps.gstatic.com/mapfiles/place_api/icons/atm-71.png" ],
    [ "baby", "https://maps.gstatic.com/mapfiles/place_api/icons/baby-71.png" ],
    [ "cafe", "https://maps.gstatic.com/mapfiles/place_api/icons/cafe-71.png" ],
    [ "car_dealer", "https://maps.gstatic.com/mapfiles/place_api/icons/car_dealer-71.png" ],
    [ "car_rental", "https://maps.gstatic.com/mapfiles/place_api/icons/car_rental-71.png" ],
    [ "courthouse", "https://maps.gstatic.com/mapfiles/place_api/icons/courthouse-71.png" ],
    [ "electronics", "https://maps.gstatic.com/mapfiles/place_api/icons/electronics-71.png" ],
    [ "fitness", "https://maps.gstatic.com/mapfiles/place_api/icons/fitness-71.png" ],
    [ "flower", "https://maps.gstatic.com/mapfiles/place_api/icons/flower-71.png" ],
    [ "gas_station", "https://maps.gstatic.com/mapfiles/place_api/icons/gas_station-71.png" ],
    [ "hospital", "https://maps.gstatic.com/mapfiles/place_api/icons/doctor-71.png" ],
    [ "jewelry", "https://maps.gstatic.com/mapfiles/place_api/icons/jewelry-71.png" ],
    [ "library", "https://maps.gstatic.com/mapfiles/place_api/icons/library-71.png" ],
    [ "lodging", "https://maps.gstatic.com/mapfiles/place_api/icons/lodging-71.png" ],
    [ "police", "https://maps.gstatic.com/mapfiles/place_api/icons/police-71.png" ],
    [ "post_office", "https://maps.gstatic.com/mapfiles/place_api/icons/post_office-71.png" ],
    [ "restaurant", "https://maps.gstatic.com/mapfiles/place_api/icons/restaurant-71.png" ],
    [ "school", "https://maps.gstatic.com/mapfiles/place_api/icons/school-71.png" ],
    [ "stadium", "https://maps.gstatic.com/mapfiles/place_api/icons/stadium-71.png" ],
    [ "supermarket", "https://maps.gstatic.com/mapfiles/place_api/icons/supermarket-71.png" ],
    [ "university", "https://maps.gstatic.com/mapfiles/place_api/icons/university-71.png" ]
  ]


// WEBPACK FOOTER //
// ./src/map_icons_text.js